<template>
    <div class="business-header">
        <div class="banner">
            <div class="main_content">
                <div class="banner-title">快麦打印机</div>
                <div class="banner-text">满足您的多场景需求</div>
            </div>
        </div>
        <div class="business-menu-box">
            <div id="business-menu" class="business-menu-box-position"></div>
            <div class="business-menu" :class="{isFixed: isFixed}">
                <div class="business-menu-item" v-for="menu in menuList" :key="menu.path"
                     :class="{active: menu.path === selectedPath}"
                     @click="routeTo(menu)"
                >
                    {{ menu.name }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Business",
    data() {
        return {
            isFixed: false,
            selectedPath: '/business/ECommerce',
            menuList: [
                {
                    path: "/business/ECommerce",
                    name: "电商行业",
                },
                /*{
                    path: "/business/LargeStorage",
                    name: "大型仓储行业",
                },*/
                {
                    path: "/business/KDWL",
                    name: "快递物流行业",
                },
                {
                    path: "/business/CYWM",
                    name: "餐饮外卖行业",
                },
                {
                    path: "/business/XXLS",
                    name: "线下零售行业",
                },
                {
                    path: "/business/YDZW",
                    name: "政务执法行业",
                },
                {
                    path: "/business/GYZZ",
                    name: "工业制造业",
                },
                {
                    path: "/business/SaaS",
                    name: "SaaS类ERP行业",
                },
            ]
        };
    },
    mounted() {
        this.selectedPath = this.$route.path;
        this.$router.afterEach((to) => {
            this.selectedPath = to.path;
        });

        // 1. 获取要观察的目标元素
        const targetElement = document.getElementById('business-menu');
        // 2. 创建一个 Intersection Observer 的回调函数
        // 这个函数会在目标元素的可见性变化时被调用
        const callback = (entries) => {
            entries.forEach(entry => {
                // entry.isIntersecting 是一个布尔值，表示目标元素是否与视口交叉
                if (entry.isIntersecting) {
                    // 元素进入了视口
                    console.log('元素可见了！');
                    this.isFixed = false;
                } else {
                    // 元素离开了视口
                    console.log('元素消失了！');
                    this.isFixed = true;
                }
            });
        };
        // 3. 创建观察器实例，并传入回调函数和选项
        const options = {
            root: null, // root 为 null 时，观察器将使用浏览器视口作为交叉区域
            rootMargin: '0px', // 类似 CSS margin，可以扩大或缩小交叉区域的边界
            threshold: 1 // 阈值，0.5 表示目标元素至少有 50% 可见时，回调函数才会被执行
        };
        const observer = new IntersectionObserver(callback, options);
        // 4. 让观察器开始观察目标元素
        observer.observe(targetElement);
    },
    methods: {
        routeTo(menu) {
            if (menu.isLink) {
                window.open(menu.path);
                return;
            }
            let route = menu.path;
            if (!route || route === this.selectedPath) {
                return;
            }
            this.$router.push(route);
        },
    },
};
</script>

<style lang="scss" scoped>
.business-header {
    .banner {
        box-sizing: border-box;
        padding: 240rem 0 0;
        height: 500rem;
        background: url("./images/bg.png") center / 1920rem 500rem no-repeat;

        .banner-title {
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 64rem;
            color: #333333;
            line-height: 90rem;
        }

        .banner-text {
            margin-top: 16erm;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 24rem;
            color: #333333;
            line-height: 34rem;
        }
    }

    .business-menu-box {
        position: relative;
        background: #ffffff;
        height: 64rem;

        // 用来监听菜单是否在视窗内，如果直接监听business-menu-box，出现横向滚动条时候，有一部分在视窗外，会被认为元素离开了视口
        .business-menu-box-position {
            position: absolute;
            top: 0;
            left: 50%;
            width: 1rem;
            height: 1rem;
        }

        .business-menu {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            gap: 16rem;
            height: 64rem;
            background: #ffffff;

            &.isFixed {
                position: fixed;
                top: 0;
                left: 0;
                right: 0;
                z-index: 9999;
            }

            .business-menu-item {
                padding: 4rem 12rem;
                cursor: pointer;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 18rem;
                color: #333333;

                &.active {
                    color: #FFFFFF;
                    font-weight: 500;
                    background: #FD6520;
                    border-radius: 100rem;
                }
            }
        }
    }
}
</style>
